/** @format */
import { commonUniversityServiceModule } from 'sis-common';
(function () {
  studyPeriodService.$inject = ["$http", "$translate", "studyPeriodModel", "universityService"];
  angular.module('student.common.service.studyPeriodService', ['pascalprecht.translate', 'student.common.model.studyPeriod', commonUniversityServiceModule]).factory('studyPeriodService', studyPeriodService);

  /**
   * @ngInject
   */
  function studyPeriodService($http, $translate, studyPeriodModel, universityService) {
    var baseUri = '/kori/api/study-periods';
    var orgIndex = 0;
    var yearIndex = 1;
    return {
      getStudyYears: getStudyYears,
      getPeriodsFor: getPeriodsFor,
      getStudyYearTemplatesForCourseUnit: getStudyYearTemplatesForCourseUnit,
      transformRepeatArrayToStudyPeriodRangesArray: transformRepeatArrayToStudyPeriodRangesArray,
      extractStudyYearPeriodFromPossibility: extractStudyYearPeriodFromPossibility
    };
    function getStudyYearTemplatesForCourseUnit(courseUnit) {
      var currentUniversityOrgId = courseUnit.universityOrgIds;
      var params = {
        organisationId: currentUniversityOrgId
      };
      return $http.get('/kori/api/study-year-templates', {
        params: params,
        cache: true
      }).then(function (result) {
        return result.data;
      });
    }
    function getStudyYears(org, firstYear, numYears) {
      return $http.get(baseUri + '/' + org + '/' + firstYear + '/' + numYears, {
        cache: true
      }).then(function (result) {
        return new studyPeriodModel.newStudyYears(result.data);
      });
    }
    function getStudyPeriods(universityOrgId, firstYear, numYears) {
      // Accept only positive integers for amount of study years to fetch, default to 1
      numYears = _.isInteger(numYears) ? Math.max(numYears, 1) : 1;
      return getStudyYears(universityOrgId, firstYear, numYears).then(function (studyYears) {
        var years = _.filter(studyYears, function (year) {
          var firstYearInt = parseInt(firstYear);
          return year.startYear >= firstYearInt && year.startYear < firstYearInt + numYears;
        });
        var periods = [];
        _.forEach(years, function (year) {
          _.forEach(year.$studyTerms, function (studyTerm) {
            _.forEach(studyTerm.$studyPeriods, function (period) {
              periods.push(period);
            });
          });
        });
        return periods;
      });
    }
    function getPeriodsFor(locator) {
      var parts = locator.split('/');
      var organisation = parts[orgIndex];
      var firstYear = parts[yearIndex];
      return getStudyPeriods(organisation, firstYear).then(function (periods) {
        return _.find(periods, function (period) {
          return period.locator === locator;
        });
      });
    }
    function extractStudyYearPeriodFromPossibility(possibilityString, studyYearTemplates) {
      var possibility = possibilityString.split('/');
      var org = possibility[0];
      var year = parseInt(possibility[1], 10);
      var term = parseInt(possibility[2], 10);
      var period = parseInt(possibility[3], 10);
      var templates = _.filter(studyYearTemplates, function (template) {
        return !_.isNil(template.org) && template.org === org;
      });
      var template = _.first(_.filter(templates, function (template) {
        if (_.isNil(template.valid)) {
          return true;
        }
        var firstDay = moment(new Date(year, 7, 1));
        var periodEndDate = moment(_.get(template, 'valid.endDate'));
        var beforeEndDateOrNoEndDate = periodEndDate.isValid() ? periodEndDate.isAfter(firstDay, 'day') : true;
        var periodStartDate = moment(_.get(template, 'valid.startDate'));
        return beforeEndDateOrNoEndDate && periodStartDate.isValid() && periodStartDate.isSameOrBefore(firstDay, 'day');
      }));
      var order = period;
      for (var i = 0; i < term; i++) {
        var length = _.get(template, 'studyTerms[' + i + '].studyPeriods.length');
        if (length === undefined) {
          return undefined;
        }
        order = order + length;
      }
      var studyYearPeriod = _.clone(_.get(template, 'studyTerms[' + term + '].studyPeriods[' + period + ']'));
      if (studyYearPeriod) {
        return _.merge(studyYearPeriod, {
          order: order
        });
      } else {
        return undefined;
      }
    }
    function transformRepeatArrayToStudyPeriodRangesArray(repeatPossibility, studyYearTemplates) {
      var reducedTemplatedPossibilities = _.transform(_.sortBy(repeatPossibility.map(function (onePossibility) {
        return extractStudyYearPeriodFromPossibility(onePossibility, studyYearTemplates);
      }), 'order'), function (result, template) {
        if (!template) {
          return true;
        }
        var lastAddition = result[result.length - 1];
        if (lastAddition && lastAddition.length > 0) {
          var latestTemplate = lastAddition.pop();
          if (template.order - latestTemplate.order === 1) {
            if (lastAddition.length === 0) {
              lastAddition.push(latestTemplate);
            }
            lastAddition.push(template);
            return true;
          } else {
            lastAddition.push(latestTemplate);
          }
        }
        result.push([template]);
        return true;
      });

      //clean obsolete field order
      reducedTemplatedPossibilities.flatMap(possibility => possibility).forEach(function (possibility) {
        _.unset(possibility, 'order');
      });
      return reducedTemplatedPossibilities;
    }
  }
})();